module.exports = __webpack_public_path__ + "static/media/done.671482d2.svg";